import { HOST } from '@/constants/Core';
import { generateUUID } from '@/helper/Core';
import { isJSON } from '@/helper/Json';
import { lookup } from './lookup';

function checkExistingImage(uri) {
    if (uri?.includes('blob:'))
        return false;

    return uri?.includes('http') || uri?.includes('writable/uploads') || uri?.includes('common/assets');
}

const getRealFilename = (uri = null) => {

    if (!uri)
        return null;

    if (!uri?.includes('/')) {
        uri = uri?.replace('LRI_', '');
        return uri;
    }

    let name = uri.slice(uri.lastIndexOf('/') + 1);
        name = name?.replace('LRI_', '');
    
    return name;
};

export const mediaFormatter = (media) => {
    const images = Array.isArray(media) ? media : [media];

    const manipulated = images?.map(image => {
        
        if (isJSON(image)) {
            
            const name = getRealFilename(image?.uri ?? image?.url);
            const mimeType = image?.mimeType ?? lookup(image?.url);
            const id = image?.id ?? generateUUID();

            return {
                ...image, 
                uri: image?.uri ?? image?.url,
                originalUri: image?.uri ?? image?.url,
                name: name,
                mediaType: mimeType,
                width: 1280, 
                height: 720, 
                id
            };
        }

        const mimeType = image?.mimeType ?? lookup(image);

        if (typeof image == 'object')
            image = image?.uri ?? image?.url ?? null;

        if (image == null)
            return null;

        const isExisting = checkExistingImage(image);

        const path = isExisting && !image?.includes('http') ?  HOST + image : image;

        const name = getRealFilename(image);

        if (mimeType?.includes('video')) {
            const uuid = image?.uuid ?? generateUUID();
            return {
                uri : path,
                originalUri : image,
                name: name,
                mediaType: 'video/mp4', 
                type: 'video', 
                width: 1280, 
                height: 720, 
                poster: path + '.thumb.jpg',
                uuid: uuid,
                id: uuid
            };
        }
        
        const includesMapImage = path?.includes('maps/map') || path?.includes('routes/map');
        const uuid = image?.uuid ?? generateUUID();

        return {
            uri : path,
            originalUri : image,
            isMapImage: includesMapImage,
            isExisting,
            name : name,
            type : mimeType,
            mediaType: mimeType,
            uuid: uuid,
            id: uuid
        }
    });

    return manipulated?.filter(image => image?.uri != null) ?? [];
}